/* eslint-disable react-hooks/exhaustive-deps */
"use client";

import React, { useEffect, useState } from "react";
import {
  Alert,
  Badge,
  Button,
  Col,
  Form,
  InputGroup,
  Modal,
  Row,
} from "react-bootstrap";
import withModalAuth from "./auth/withModalAuth";
import Image from "next/image";
import { googleMapsKey, marketplaceCdn } from "../utility/env";
import styles from "../styles/Order.module.css";
import Select from "react-select";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  ApplyVoucherCode,
  getCities,
  getDeliveryCharges,
} from "../app/apis/getApis";
import { useUserStore } from "../store/User";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinus,
  faPlus,
  faShippingFast,
  faShop,
  faTicket,
  faTicketSimple,
  faTruck,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import InputMask from "react-input-mask";
import { PlaceOrder } from "../app/apis/postApis";
import { useRouter } from "next/navigation";
import Loaderstyles from "../styles/ButtonLoader.module.css";

import ButtonLoader from "./ButtonLoader";
import { faClock, faPlusSquare } from "@fortawesome/free-regular-svg-icons";

interface Props {
  onHide: () => void;
  show: boolean;
  data: any;
}
interface initialvalues {
  quantity: number;
  note: string;
  phoneNumber: string;
  city?: {
    value: string;
    label: string;
  };
  email: string;
  address: string;
  name: string;
}

interface coordiate {
  lat: number;
  lng: number;
}

function OrderModal(props: Props) {
  const [cities, setCities] = useState<any[]>([]);
  const [validated, setValidated] = useState(false);
  const { user, token, location } = useUserStore((state: any) => state);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [city, setCity] = useState("");
  const navigation = useRouter();
  const [error, setError] = useState<string>("");
  const [deliveryCharges, setDeliveryCharges] = useState<any>([]);
  const [voucherCode, setVoucherCode] = useState<string>("");
  const [discoundValue, setDiscoundValue] = useState<number>(0);
  const [voucherData, setVoucherData] = useState<any>(null);
  const [voucherApplied, setVoucherApplied] = useState<boolean>(false);
  const [voucherError, setVocherError] = useState<string>("");
  const [initialValues, setInitialValues] = useState<initialvalues>({
    quantity: 1,
    note: "",
    phoneNumber: user ? user.phone_number : "",
    city: {
      value: "",
      label: "",
    },
    address: "",
    email: user ? user.email : "",
    name: user ? `${user.first_name} ${user.last_name}` : "",
  });

  const handleDecreaseCart = () => {
    if (initialValues.quantity > 1) {
      setInitialValues({
        ...initialValues,
        quantity: initialValues.quantity - 1,
      });
    }
  };

  const handleIncreaseCart = () => {
    if (props.data.item.quantity >= initialValues.quantity) {
      setInitialValues({
        ...initialValues,
        quantity:
          initialValues.quantity < props.data.item.quantity
            ? initialValues.quantity + 1
            : initialValues.quantity,
      });
    }
  };

  const fetchCities = useQuery({
    queryKey: ["cities"],
    queryFn: () => getCities(),
    onSuccess: (data) => {
      setCities(
        data?.data?.body?.data.map((item: any) => {
          return {
            label: item.city_name,
            value: item.city_id,
          };
        })
      );
    },
  });
  const fetchDeliveryCharges = useQuery({
    queryKey: ["charges", location],
    queryFn: () => getDeliveryCharges(token),
    onSuccess: (data) => {
      setLoading(false);
    },
  });

  // const deliveryCharges =
  const citiesOp = fetchCities.data?.data?.body?.data
    .filter((item: { city_id: number }) => item.city_id === 1)
    .map((item: { city_name: string; city_id: number }) => {
      return {
        label: item.city_name,
        value: item.city_id,
      };
    });

  const handleApplyVoucher = useMutation({
    mutationKey: ["voucher", voucherCode, initialValues?.quantity], // Ensure initialValues?.quantity is used safely

    mutationFn: () => ApplyVoucherCode(voucherCode),
    onSuccess: (data) => {
      setVoucherData(data?.data?.body?.data);
      setVocherError("");

      setDiscoundValue(
        CalculatePriceAfterVoucher(
          props?.data?.effective_price * initialValues?.quantity,
          total,
          data?.data?.body?.data?.discount_value,
          data?.data?.body?.data?.discount_unit,
          data?.data?.body?.data
        )
      );

      // return data?.data?.body?.data;
    },
    onError: (error: any) => {
      setVocherError(error?.response?.data?.body?.message?.replace(`"`, ""));
    },
  });

  useEffect(() => {
    const basePrice =
      Number(initialValues?.quantity) * Number(props?.data?.effective_price);
    const shippingCharge = Number(
      deliveryCharges.length === 0 ? 0 : Number(deliveryCharges[0]?.charges)
    );

    if (voucherData && discoundValue) {
      const newTotal = CalculatePriceAfterVoucher(
        basePrice,
        basePrice + shippingCharge, // Pass total price including shipping
        voucherData?.discount_value,
        voucherData?.discount_unit,
        voucherData
      );

      setDiscoundValue(newTotal);
    } else {
      setTotal(basePrice + shippingCharge); // Default total if no voucher
    }
  }, [deliveryCharges, initialValues]);

  const CalculatePriceAfterVoucher = (
    price: number,
    total: number,
    discount_value: number,
    discount_unit: string,
    voucherData: any
  ): number => {
    if (+price >= +voucherData?.min_order_amount) {
      if (discount_unit === "percentage") {
        setVoucherApplied(true);

        let dv = (+price * +discount_value) / 100;
        dv = Math.min(dv, +voucherData?.capped_amount);
        return total - dv;
      } else if (discount_unit === "fixed" && total > discount_value) {
        setVoucherApplied(true);
        let discountedValue = total - discount_value;

        return discountedValue;
      } else {
        setVoucherApplied(false);
        return total;
      }
    } else {
      setVocherError(
        "Order amount is below the minimum allowed for this voucher."
      );
      return total;
    }
  };

  const PlaceOrderMutaition: any = useMutation({
    mutationFn: (data) => PlaceOrder(data, token),
    onSuccess: (data, variables, context) => {
      navigation.push(
        `/order-confirmation?on=${data.data.body.data.result.order_number}`
      );
      // Boom baby!
    },
    onError: (error: any) => {
      setLoading(false);
      setError(Object.values(error.response.data.message[0].message)[0]);
    },
  });

  const handleChange = (e: any) => {
    setInitialValues({ ...initialValues, [e.target.name]: e.target.value });
  };

  const handleVoucherSubmit = (e: any): any => {
    e.preventDefault();
    handleApplyVoucher.mutate();
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (loading) return;
    setValidated(true);
    setLoading(true);
    function calculateVoucherDiscount() {
      // Ensure valid input values
      const effectivePrice = parseFloat(props?.data?.effective_price) || 0;
      const minOrderAmount = parseFloat(voucherData?.min_order_amount) || 0;
      const discountValue = parseFloat(voucherData?.discount_value) || 0;
      const cappedAmount = parseFloat(voucherData?.capped_amount) || 0;

      // Check if the effective price meets the minimum order amount
      if (effectivePrice >= minOrderAmount) {
        if (voucherData?.discount_unit === "percentage") {
          // Calculate the discount value

          let discount = (effectivePrice * discountValue) / 100;
          // Cap the discount value if it exceeds the capped amount
          discount = Math.min(discount, cappedAmount);
          return discount;
        } else if (voucherData?.discount_unit === "fixed") {
          return voucherData?.discount_value;
        }
      }

      // Return 0 if conditions are not met
      return 0;
    }

    const obj = {
      product_title: props?.data?.listing_title,
      original_price: props?.data?.online_price,
      discount_unit: props.data.online_discount_unit,
      voucher_discount: calculateVoucherDiscount(),
      fk_voucher_id: voucherData?.id,
      discount_value:
        props?.data?.discount_percentage !== null
          ? props?.data?.discount_percentage
          : 0,
      quantity: initialValues?.quantity,
      price: props?.data?.effective_price,
      total_price: discoundValue ? discoundValue : total,
      notes: initialValues?.note,
      customer_name: initialValues?.name,
      customer_email: initialValues?.email,
      customer_phone: initialValues?.phoneNumber,
      customer_address: initialValues?.address,
      fk_item_id: props?.data?.item?.item_id,
      fk_listing_id: props?.data?.listing_id,
      fk_customer_id: user ? user.uuid : null,
      fk_shop_id: props?.data?.item?.shopTable?.shop_id,
      fk_location_id: props?.data?.item?.location_id,
      delivery_charges: deliveryCharges[0]?.charges,
      user_type: user ? "customer" : "guest",
    };
    if (
      props?.data?.item?.location?.city.city_name === initialValues?.city?.label
    ) {
      PlaceOrderMutaition.mutate(obj, token);
    }
  };

  const calculatePrice = (price: any, discount: any, discountUnit: any) => {
    if (discountUnit === "percentage") {
      return price - price * (discount / 100);
    } else if (discountUnit === "fixed") {
      return price - discount;
    }
  };

  useEffect(() => {
    setInitialValues({
      ...initialValues,
      name: user ? user.first_name + " " + user.last_name : "",
      phoneNumber: user?.phone_number,
      email: user?.email,
    });
  }, [user]);

  useEffect(() => {
    // citiesOp?.map((item: any) => {

    //     if (item.label === props?.data?.item?.location?.city.city_name) {
    //         setInitialValues({ ...initialValues, city: { value: item.value, label: item.label } })
    //     }
    // })
    fetchDeliveryCharges.data?.data?.body?.data.map((item: any) => {
      if (item.city_id === initialValues?.city?.value) {
        if (item.category_id === props?.data?.item?.category_id) {
          setDeliveryCharges([item]);
        }
      }
    });
  }, [initialValues, fetchDeliveryCharges.data?.data?.body?.data, props.show]);


  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => {
          props.onHide();
          setInitialValues({
            quantity: 1,
            note: "",
            phoneNumber: "",

            address: "",
            email: user?.email,
            name: user ? user.first_name + " " + user.last_name : "",
          });
          setValidated(false);
          setVoucherData(null);
          setVoucherCode("");
          setDiscoundValue(0);
          setVocherError("");
          setVoucherApplied(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title className="py-2" id="contained-modal-title-vcenter">
            Buy Now
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="itemsDiv px-2">
            <Row className={`bg-light  ${styles.itemCard} p-3 mx-1  `}>
              <Col lg="12" md="12" className="d-flex ">
                <div className="p-2 rounded d-flex align-items-center   ">
                  <Image
                    style={{ objectFit: "contain" }}
                    className={`${styles.itemImg} `}
                    alt={props?.data?.listing_title}
                    src={` ${marketplaceCdn}/${props.data?.item?.itemImages[0] || props.data?.item?.itemImages?.img0}`}
                    width={100}
                    height={80}
                  />
                </div>
                <Row className="">
                  <Col
                    lg="12"
                    md="12"
                    xs="12"
                    sm="12"
                    className={`${styles.itemDetails}}`}
                  >
                    <p className={`text-dark fw-500 mb-1  ${styles.itemTitle}`}>
                      {props?.data?.listing_title}{" "}
                      <Badge className={`${styles.badge}`}>
                        {props?.data?.item?.condition_item}
                      </Badge>
                    </p>
                    <p
                      className={`text-dark fw-700 fs-18 align-items-center w-100 d-flex  gap-2 mb-0 ${styles.itemPrice}`}
                    >
                      Rs{" "}
                      {calculatePrice(
                        props?.data?.online_price,
                        props?.data?.online_discount,
                        props?.data?.online_discount_unit
                      )?.toLocaleString("en-IN")}
                      {props?.data?.online_discount ? (
                        <p
                          className={`text-decoration-line-through fs-14 text-muted mb-0 `}
                        >
                          Rs{" "}
                          {props?.data?.online_price?.toLocaleString("en-IN")}
                        </p>
                      ) : (
                        ""
                      )}
                    </p>
                  </Col>
                  <Col
                    lg="3"
                    md="5"
                    xs="8"
                    sm="5"
                    style={{ height: "30px" }}
                    className="d-flex  justify-content-between  mt-1  w-100 "
                  >
                    <div className="d-flex ">
                      <button
                        className={` btn btn-secondary mx-1 px-2 d-flex align-items-center rounded-1  `}
                        onClick={handleDecreaseCart}
                      >
                        <FontAwesomeIcon className="fs-12 " icon={faMinus} />
                      </button>
                      <Form.Control
                        type="number"
                        className=" p-0  px-0 text-center w-25"
                        min="1"
                        minLength={1}
                        // max={max}
                        placeholder="1"
                        value={initialValues.quantity}
                        onChange={(e) => {}}

                        // onBlur={(e) => handleFocusOut(e, cartItem)}
                      />
                      <button
                        className={` btn btn-secondary mx-1 px-2 d-flex align-items-center rounded-1  `}
                        onClick={handleIncreaseCart}
                      >
                        <FontAwesomeIcon className="fs-12" icon={faPlus} />
                      </button>
                    </div>
                  </Col>
                  {/* <Col lg="12" className={`d-flex justify-content-start align-items-start w-100 `}>
                                        <span className='text-center w-100 text-muted fs-14 mt-1 '> <FontAwesomeIcon icon={faTruck} />  Deliver from <span className='fw-700' > {props?.data?.item?.location?.city.city_name}</span></span>

                                    </Col> */}
                </Row>

                {/* <div className="vr m-3 d-none d-md-block d-lg-block"></div> */}
              </Col>

              {/* <Col lg="2" md="12" xs="12" className=' mt-1 d-flex d-lg-grid d-md-grid d-block gap-2 align-items-start ' >
                                <div className='d-flex gap-1 justify-content-start w-100'>
                                    <p className='text-dark fw-500 text-start mb-0 mt-0 p-0 ' >Shipping  </p>
                                    <p className='text-dark fw-500 text-start text-muted  ' >Rs  {deliveryCharges[0]?.charges ? deliveryCharges[0]?.charges : 0} </p>
                                </div>
                                <div className='d-flex gap-1 w-100 justify-content-end '>
                                    <p className='text-dark fw-700 text-start text-bold fs-16 m-0 ' >Total:</p>
                                    {<p className='text-dark fw-700 text-start text-bold fs-16 m-0 ' > Rs {total} </p>}
                                </div>
                            </Col> */}
            </Row>
            <Row className=" rounded p-1 d-flex mt-2">
              <Col lg="12" className="">
                <Form
                  validated={validated}
                  onSubmit={handleSubmit}
                  className=""
                >
                  <div className="d-lg-flex d-md-flex d-grid  gap-2 mt-3 ">
                    <Form.Group className="w-100">
                      {/* <Form.Label className="mb-1">
                                                Name <span className="text-danger ">*</span>
                                            </Form.Label> */}
                      <Form.Control
                        onChange={handleChange}
                        name="name"
                        required
                        className="py-2"
                        placeholder="Name"
                        type="text"
                        value={initialValues.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        Enter Name
                      </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="w-100">
                      {/* <Form.Label className="mb-1">
                                                Email
                                            </Form.Label> */}
                      <Form.Control
                        onChange={handleChange}
                        name="email"
                        className="py-2"
                        placeholder="Email"
                        type="email"
                        value={initialValues.email}
                      />
                      <Form.Control.Feedback type="invalid">
                        Enter Email
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <div className="d-lg-flex d-md-flex d-grid  gap-2 mt-3">
                    <Form.Group className="w-100">
                      {/* <Form.Label className="mb-1">
                                                Phone number <span className="text-danger ">*</span>
                                            </Form.Label> */}
                      <InputMask
                        className="w-100"
                        mask="+\92-399-9999999"
                        value={initialValues.phoneNumber}
                        name="phoneNumber"
                        onChange={handleChange}
                        required
                      >
                        <Form.Control
                          isValid={
                            validated && initialValues.phoneNumber.length === 15
                          }
                          isInvalid={
                            validated && initialValues.phoneNumber.length < 15
                          }
                          minLength={15}
                          className="border-dark w-75"
                          placeholder="+92-3XX-XXXXXXX"
                          type="tel"
                          required={true}
                        />
                      </InputMask>
                      <Form.Control.Feedback type="invalid">
                        Invalid Phone Number
                      </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3 w-100 ">
                      {/* <Form.Label className="">
                                                City <span className="text-danger ">*</span>
                                            </Form.Label> */}

                      <Select
                        className=""
                        // isDisabled={true}
                        classNamePrefix={"Select "}
                        placeholder={"Select City"}
                        isSearchable
                        name="city"
                        value={initialValues?.city}
                        onChange={(e) => {
                          if (e) {
                            setInitialValues({ ...initialValues, city: e });
                          }
                        }}
                        options={citiesOp}
                        // filterOption={createFilter(filterConfig)}
                      />
                      {/* <Form.Control value={initialValues?.city.label} hidden name="city" required /> */}
                      <small className="text-muted fs-12 ">
                        We only deliver within this city (intercity deliveries
                        are not available)
                      </small>
                      <Form.Control.Feedback type="invalid">
                        * Please Select city.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </div>
                  <Form.Group>
                    {/* <Form.Label className="mb-1">
                                            Address <span className="text-danger ">*</span>
                                        </Form.Label> */}
                    <Form.Control
                      required
                      onChange={handleChange}
                      name="address"
                      className="py-2"
                      placeholder="Address"
                      type="text"
                      value={initialValues.address}
                    />
                    <Form.Control.Feedback type="invalid">
                      Enter the Address
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group
                    className="mt-2"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    {/* <Form.Label className="mb-1">
                                            Note <span className="text-danger ">*</span>
                                        </Form.Label> */}

                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="note"
                      placeholder="Enter Note"
                      onChange={handleChange}
                      value={initialValues.note}
                    />
                    <Form.Control.Feedback type="invalid">
                      Enter Note
                    </Form.Control.Feedback>
                  </Form.Group>
                  {(location
                    ? props?.data?.item?.location?.city.city_name !== location
                    : true) && (
                    <Alert
                      className="py-1 d-flex align-items-center gap-2 mt-2 "
                      key={1}
                      variant={"warning"}
                    >
                      <FontAwesomeIcon icon={faWarning} /> We are not providing
                      intercities deliveries for now
                    </Alert>
                  )}

                  <div
                    className={`mt-2 bg-light px-2 ${initialValues?.city?.value ? "" : "d-none"}`}
                  >
                    <span className="fs-18 text-center d-flex justify-content-center align-items-center  fw-bold p-2">
                      Order Details
                    </span>
                    <hr className="pt-0 mt-0" />
                    <div className="d-flex justify-content-between row px-2">
                      <span
                        className={`text-dark  col-8  fw-500   nowrap  mb-0 mt-0 p-0 ${styles.itemTitle}`}
                      >
                        {props?.data?.listing_title}{" "}
                      </span>
                      <p
                        className={`text-dark  fw-500 col-4 text-end text-muted  ${styles.itemPrice}`}
                      >
                        Rs {props?.data?.online_price?.toLocaleString("en-IN")}{" "}
                      </p>
                    </div>

                    <div className="d-flex justify-content-between row px-2">
                      <span
                        className={`text-dark d-flex  col-8 fw-500 text-center justify-content-between  mb-0 mt-0 p-0 ${styles.itemTitle}`}
                      >
                        Quantity:{" "}
                      </span>
                      <p
                        className={`${styles.itemPrice} text-dark fw-500 col-4 text-end text-muted  `}
                      >
                        {initialValues.quantity}{" "}
                      </p>
                    </div>
                    {props?.data?.online_discount > 0 && (
                      <div className="d-flex justify-content-between row px-2">
                        <span
                          className={`text-dark  col-8  fw-500   nowrap  mb-0 mt-0 p-0 ${styles.itemTitle}`}
                        >
                          {" "}
                          Total Discount{" "}
                        </span>
                        <p
                          className={`text-dark  fw-500 col-4 text-end text-muted  ${styles.itemPrice}`}
                        >
                          Rs{" "}
                          {props.data?.online_discount_unit === "fixed"
                            ? Number(props?.data?.online_discount) *
                              Number(initialValues.quantity).toLocaleString(
                                "en-IN"
                              )
                            : Number(
                                (props?.data?.online_price *
                                  props?.data?.online_discount) /
                                  100
                              )}{" "}
                        </p>
                      </div>
                    )}

                    <div className="d-flex justify-content-between row px-2">
                      <span
                        className={`text-dark d-flex col-8 fw-500 text-end justify-content-between  mb-0 mt-0 p-0 ${styles.itemTitle}`}
                      >
                        <div className=""> Estimated Shipping Time:</div>
                      </span>
                      <p
                        className={`text-dark fw-500 text-end col-4 text-muted ${styles.itemPrice}`}
                      >
                        24 - 48 hrs
                      </p>
                    </div>

                    <div className="d-flex justify-content-between row px-2 align-items-start">
                      <span
                        className={`text-dark d-flex col-8 fw-500  text-end justify-content-between  mb-0 mt-0 p-0 ${styles.itemTitle}`}
                      >
                        <div className="">
                          <FontAwesomeIcon icon={faShippingFast} /> Standard
                          Shipping:
                        </div>
                      </span>
                      <p
                        className={`text-dark fw-500 text-end col-4 text-muted ${styles.itemPrice}`}
                      >
                        Rs{" "}
                        {Number(
                          deliveryCharges.length > 0
                            ? deliveryCharges[0].charges
                            : 0
                        )}{" "}
                      </p>
                    </div>

                    <div
                      className={`d-flex justify-content-between flex-column flex-lg-row ${voucherApplied ? "d-none" : ""} `}
                    >
                      <span
                        className={`text-dark d-flex col-8 fw-500 text-end justify-content-between me-2  align-items-center   ${styles.voucherRow}  mb-1 mt-0 p-0 ${styles.itemTitle}`}
                      >
                        <FontAwesomeIcon
                          className="align-items-center me-1"
                          icon={faTicket}
                        />
                        <div className="">Have a Voucher?</div>
                      </span>
                      <Form className="  " onClick={handleVoucherSubmit}>
                        <div className="d-flex ">
                          <Form.Control
                            className={`${styles.voucher_input} `}
                            placeholder="Enter the voucher code"
                            style={{
                              height: "30px",
                            }}
                            isInvalid={voucherError ? true : false}
                            value={voucherCode}
                            onChange={(e) => setVoucherCode(e.target.value)}
                          />
                          <Button
                            // type="submit"
                            variant="outline-primary"
                            style={{ height: "30px" }}
                            className={`rounded-end text-nowrap d-flex align-items-center ${
                              voucherCode.length > 0 && total ? "" : "disabled"
                            } ${styles.Voucher_btn}`}
                          >
                            Apply Voucher
                          </Button>
                        </div>
                        {voucherApplied && (
                          <p
                            className="text-muted "
                            style={{ fontSize: "10px" }}
                          >
                            Max Cap: Rs. {voucherData?.capped_amount}
                          </p>
                        )}

                        <Form.Control.Feedback
                          className={`mt-1 ${styles.error} text-danger ${voucherError ? "d-flex text-nowrap mb-2 " : "d-none"}`}
                          type="invalid"
                        >
                          {voucherError}
                        </Form.Control.Feedback>
                      </Form>
                    </div>
                    {voucherData && voucherApplied && !voucherError ? (
                      <div className="d-flex justify-content-between row px-2">
                        <span
                          className={`text-dark d-flex col-8 fw-500 text-end justify-content-between me-2  align-items-center   ${styles.voucherRow}  mb-1 mt-0 p-0 ${styles.itemTitle}`}
                        >
                          <FontAwesomeIcon
                            className="align-items-center me-1"
                            icon={faTicket}
                          />
                          <div className="">
                            Voucher Applied ({voucherData?.voucher_code}):{" "}
                          </div>
                        </span>
                        <p
                          className={`text-dark fw-500 text-end col-4 text-muted ${styles.itemPrice}`}
                        >
                          {voucherData.discount_unit === "percentage"
                            ? `${Number(voucherData?.discount_value)?.toFixed(0)}% ${props?.data?.effective_price * (voucherData?.discount_value / 100) > +voucherData?.capped_amount ? `(Rs ${+voucherData?.capped_amount})` : ``}`
                            : ` Rs ${voucherData?.discount_value}`}
                        </p>
                      </div>
                    ) : null}

                    <div className="d-flex justify-content-center  px-2">
                      <span
                        className={`text-dark d-flex  fw-500 text-end   mb-0 mt-0 p-0 ${styles.itemTitle}`}
                      >
                        Sold by :
                        <strong className="ms-1">
                          {props?.data?.item?.shopTable.shop_name}
                        </strong>{" "}
                      </span>
                    </div>
                    <hr className="mb-0" />
                    <p className="fs-18 text-center fw-bold p-2 ">
                      Total : {discoundValue ? discoundValue : total}
                    </p>
                  </div>
                  <ButtonLoader />
                  {error && (
                    <Alert variant="danger" className="mt-1 p-1 text-center">
                      {error.replaceAll("_", " ")}
                    </Alert>
                  )}
                  {
                    <Button
                      disabled={initialValues?.city?.value ? false : true}
                      type="submit"
                      className={`w-100 mt-3  `}
                    >
                      {" "}
                      {loading ? <ButtonLoader /> : "Checkout"}{" "}
                    </Button>
                  }
                </Form>
              </Col>
            </Row>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default OrderModal;
